import React from 'react';
import { useField, useFormikContext } from 'formik';
import { Textarea } from '../ui/Textarea';
import { cn } from '../../utils/cn';

interface AreaFormFieldProps {
  name: string;
  label?: string;
  disabled?: boolean;
  placeholder?: string;
  limit?: number;
  rows?: number;
  className?: string;
  required?: boolean;
  [key: string]: unknown;
}

export const AreaFormField: React.FC<AreaFormFieldProps> = ({
  name,
  label,
  disabled,
  placeholder,
  limit,
  rows = 5,
  className,
  required,
}) => {
  const [field, meta] = useField(name);
  const { submitCount } = useFormikContext();
  const hasError = (meta.touched || submitCount > 0) && !!meta.error;
  const errorMsg = hasError ? meta.error : null;

  return (
    <div className={cn('flex flex-col gap-1', className)}>
      {label && (
        <label htmlFor={name} className="text-sm font-medium text-neutral-700">
          {label}
          {required && <span className="text-destructive ml-0.5">*</span>}
        </label>
      )}
      <div className="relative">
        <Textarea
          id={name}
          data-testid={`area-form-field-${name}`}
          disabled={disabled}
          placeholder={placeholder}
          maxLength={limit}
          rows={rows}
          aria-invalid={hasError}
          {...field}
        />
        {limit && (
          <span className="absolute bottom-2 right-2 text-xs text-neutral-400">
            {field.value?.length || 0}/{limit}
          </span>
        )}
      </div>
      {hasError && <span className="text-destructive text-xs">{errorMsg}</span>}
    </div>
  );
};
